import * as c from '../constants/DpaAgreementConstants'

const initialState = {
  fetching: false,
  fetched: false,
  fetchError: null,
  data: null,
}

export const dpaAgreement = (state = initialState, { type, payload }) => {
  switch (type) {
    case c.FETCH_DPA_AGREEMENT_REQUEST_PENDING:
      return { ...state, fetching: true, fetched: false, fetchError: null }
    case c.FETCH_DPA_AGREEMENT_REQUEST_FULFILLED:
      return { ...state, fetching: false, fetched: true, data: payload }
    case c.FETCH_DPA_AGREEMENT_REQUEST_REJECTED:
      return {
        ...state,
        fetching: false,
        fetched: false,
        fetchError: payload,
      }

    default:
      return state
  }
}
